import api from "../api"

export const riskAPI={
	async getAll(MatrixID){
		let value = await api.get(`/risk/` , { params: { MatrixID: MatrixID } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async createRisk(MatrixID,Risk, RiskDescription, TypesOfRisk, RiskOwner, Created, Creator, Consequence, Probability){
		let value = await api.post(`/risk/`,{
			MatrixID: MatrixID,
			Risk: Risk,
			RiskDescription: RiskDescription,
			TypesOfRisk: TypesOfRisk,
			RiskOwner: RiskOwner,
			Created: Created,
			Creator: Creator,
			Consequence: Consequence,
			Probability: Probability
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},	async deleteRisk(ID) {
		if (isNaN(parseInt(ID))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/risk/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	}, async getRiskById(ID){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.get(`/risk/${ID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}, async updateRiskById(ID,Risk, RiskDescription, TypesOfRisk, RiskOwner, Created, Creator, Consequence, Probability){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/risk/${ID}`,{
			Risk: Risk,
			RiskDescription: RiskDescription,
			TypesOfRisk: TypesOfRisk,
			RiskOwner: RiskOwner,
			Created: Created,
			Creator: Creator,
			Consequence: Consequence,
			Probability: Probability
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}, async updateRiskNewPointById(ID, UpdatedDate, UpdatedConsequence, UpdatedProbability, CommentforUpdate){
		if(isNaN(parseInt(ID))){
			throw Error("ID must be a number")
		}
		let value = await api.put(`/risk/${ID}/update`,{
			UpdatedDate: UpdatedDate,
			UpdatedConsequence: UpdatedConsequence,
			UpdatedProbability: UpdatedProbability,
			CommentforUpdate: CommentforUpdate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	}
}